import { useState } from "react";
import { DialogContent } from "@mui/material";
import { JobsComponent } from "../../pages/Jobs/jobs.page";
import { CustomMobileDialog } from "./custom-mobile-dialog.component";
import { Logger } from "@/lib/logger/Logger";
import { attachFile } from "../../lib/utils";
import { useCentralStore } from "../../store/Central";
import { JobEntityType } from "../../../../lib/supabase/supabaseTypes";
import { useNavigate } from "react-router-dom";
import { showNotification } from "../../store/Central/selectors";
import { Loading } from "@/components/src/animations/loading";
export const AttachDialog = ({
	image,
	onClose,
}: {
	image: File;
	onClose: () => void;
}) => {
	const { profile } = useCentralStore.getState();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const onSelect = async (jobId: string) => {
		if (image) {
			setLoading(true);
			if (profile) {
				await attachFile(image, profile, Number(jobId));
				navigate(`/job/${jobId}/1`);
				onClose();
			} else {
				Logger.error("No profile found");
				showNotification({
					message: "Fehler bei der Anmeldung",
					type: "error",
				});
			}
			setLoading(false);
		}
	}

	return (
		<CustomMobileDialog open={!!image} onClose={onClose} title="Wählen Sie einen Auftrag aus">
			<DialogContent>
				<div
					id="job"
					className="mt-4 h-full flex flex-col gap-2"
				>
						{loading ? (
							<div className="flex flex-col items-center gap-2">
								<Loading />
								<span>Das Bild wird angehängt...</span>
							</div>
					) : (
						<JobsComponent onSelect={onSelect}/>
					)}
				</div>
			</DialogContent>
		</CustomMobileDialog>
	);
};
